"use client";

import { Typography } from "@/components/ui/typography";
import { faqItems } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import {
  FaqStack as FaqStackContent,
  FaqLinkBlock,
} from "@/components/screen/global-components/faq";

const AffiliateFAQ = ({ className }: React.ComponentProps<"section">) => {
  return (
    <section className={cn("section bg-background-secondary", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div>
          <Typography
            variant="heading4"
            className="text-semantic-text-primary md:text-gray-800"
            asChild
          >
            <h2>Frequently asked questions</h2>
          </Typography>
          <FaqStackContent items={faqItems} className="mt-6" />
        </div>
        <FaqLinkBlock
          className="mt-6 py-4 sm:p-0"
        />
      </div>
    </section>
  );
};

export default memo(AffiliateFAQ);
